export default {"src":"/_next/static/media/prevArrow.fa633cbd.svg","height":56,"width":56};